import { gql } from '@apollo/client';
import { IsCharityAdminFragment } from '../../types/__generated__';
import { useAuthenticateUser } from './useAuthenticateUser';
import usePageQuery, { buildQuery } from './usePageQuery';
import { filterByTypename } from '../utils/graphql';

const FRAGMENT = buildQuery(gql`
  fragment IsCharityAdmin on Page {
    relationships {
      beneficiaries(first: 1) {
        nodes {
          ... on Charity {
            id
            legacyId
          }
        }
      }
    }
  }
`);

export function useCharityAdmin() {
  const { activeCharityPermission } = useAuthenticateUser();
  const { data, loading, error } = usePageQuery<IsCharityAdminFragment>(
    FRAGMENT,
  );

  const beneficiaries = data?.relationships?.beneficiaries;
  const charity = beneficiaries?.nodes
    ? filterByTypename(beneficiaries?.nodes, 'Charity')
    : null;
  const charityId = (charity && charity[0]?.legacyId?.toString()) ?? '';

  const isCharityAdmin =
    activeCharityPermission?.groupTypeExternalId === charityId &&
    activeCharityPermission?.roles.includes('admin')
      ? true
      : false;

  const unauthenticatedUser = {
    isCharityAdmin: false,
    isCheckingCharityAdmin: loading,
    data,
    error,
  };

  if (loading || !activeCharityPermission || !charityId) {
    return unauthenticatedUser;
  }

  return {
    isCharityAdmin,
    isCheckingCharityAdmin: loading,
    data,
    error,
  };
}
